/**
 * Which *platform* surface is being served.
 *
 * `itcitysoft.com` / `itcity.ltd` and `possignin.com` are BOTH platform hosts —
 * `brand.isPlatform` is true for all of them — but they are two different public
 * identities: ITCity is the parent company, Possignin is its product. The brand
 * resolver cannot tell them apart, so any surface whose content differs between
 * the two must ask here.
 *
 * This lived inline in routes.tsx. It moved out once a second and third caller
 * appeared (the blog namespace and the header mark), because three copies of a
 * hostname list is three chances for them to disagree.
 */

const ITCITY_HOSTS = ['itcitysoft.com', 'itcity.ltd'] as const;

/**
 * True on the ITCity parent-company site (apex or any subdomain).
 *
 * SSR-safe: returns false when there is no `window`, which makes the Possignin
 * product surface the default. That is the right way round — a wrong `true` would
 * show ITCity company content on possignin.com, which is the louder mistake.
 */
export function isItcityHost(hostname?: string): boolean {
  const host = (hostname ?? (typeof window !== 'undefined' ? window.location.hostname : '')).toLowerCase();
  if (!host) return false;
  return ITCITY_HOSTS.some((h) => host === h || host.endsWith(`.${h}`));
}
